<template>
    <section>
        <b-table
            :data="data"
            :paginated="defConfig.isPaginated"
            :per-page="defConfig.perPage"
            :current-page.sync="defConfig.currentPage"
            :pagination-simple="defConfig.isPaginationSimple"
            :pagination-position="defConfig.paginationPosition"
            :default-sort-direction="defConfig.defaultSortDirection"
            :sort-icon="defConfig.sortIcon"
            :sort-icon-size="defConfig.sortIconSize"
            :checkable="defConfig.checkable"
            :checked-rows.sync="checkedrows_"
            :header-checkable="false"
            :selected.sync="selected_"
            :hoverable="defConfig.hoverable"
            :striped="defConfig.striped"
            :default-sort="defConfig.defaultSort"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            >
            <!-- 親コンポーネントのslot-scopeを子コンポーネントに渡す -->
            <!-- https://qiita.com/TomK/items/fec2ab759d2d9c22382b -->
             <template v-for="(slot, name) of $scopedSlots" #[name]="data">
                <slot :name="name" v-bind="data"></slot>
            </template>
        </b-table>
    </section>
</template>
<script>
export default {
    props: {
        data: {
            type: Array,
            required: true
        },
        config: {
            type: Object,
            required: false,
            default: () => {return {}}
        },
        selected: {
            type: Object,
            required: false,
            default: null
        },
        checkedrows: {
            type: Array,
            required: false,
            default: () => []
        },
    },
    data() {
        return {
            defConfig: {
                mobileCard: (this.config.mobileCard !== undefined) ? this.config.mobileCard : true,
                isPaginated: (this.config.isPaginated !== undefined) ? this.config.isPaginated : true,
                perPage: (this.config.perPage !== undefined) ? this.config.perPage : 10,
                currentPage: (this.config.currentPage !== undefined) ? this.config.currentPage : 1,
                isPaginationSimple: (this.config.isPaginationSimple !== undefined) ? this.config.isPaginationSimple : false,
                paginationPosition: (this.config.paginationPosition !== undefined) ? this.config.paginationPosition : 'bottom',
                defaultSortDirection: (this.config.defaultSortDirection !== undefined) ? this.config.defaultSortDirection : 'asc',
                sortIcon: (this.config.sortIcon !== undefined) ? this.config.sortIcon : 'arrow-up',
                sortIconSize: (this.config.sortIconSize !== undefined) ? this.config.sortIconSize : 'is-small',
                checkable: (this.config.checkable !== undefined) ? this.config.checkable : true,
                hoverable: (this.config.hoverable !== undefined) ? this.config.hoverable : true,
                striped: (this.config.striped !== undefined) ? this.config.striped : true,
                defaultSort: (this.config.defaultSort) ? this.config.defaultSort : "asc",
                centered: (this.config.centered !== undefined) ? this.config.centered : false,
            },
        }
    },
    computed: {
        // 親 <---> 孫 でデータを受け渡す方法
        // https://waino.hateblo.jp/entry/2018/10/22/115853
        selected_: {
            get () {
                return this.selected
            },
            set (value) {
                this.$emit('update:selected', value)
            }
        },
        checkedrows_: {
            get () {
                return this.checkedrows
            },
            set (value) {
                this.$emit('update:checkedrows', value)
            }
        },
    }
}
</script>
